// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"f1bd4a8c","977":"6be499f6"}[chunkId] + ".chunk.js";
};